import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { I18nProvider, useI18n } from "@/contexts/I18nContext";
import { AuthProvider } from "@/contexts/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AuthModal from "@/components/AuthModal";
import ScrollToTop from "@/components/ScrollToTop";
import useSEO from "@/lib/useSEO";
import Landing from "@/pages/Landing";
import Browse from "@/pages/Browse";
import ListingDetail from "@/pages/ListingDetail";
import CreateListing from "@/pages/CreateListing";
import Profile from "@/pages/Profile";
import Messages from "@/pages/Messages";
import AlertsPage from "@/pages/AlertsPage";
import AuthCallback from "@/pages/AuthCallback";
import PaymentReturn from "@/pages/PaymentReturn";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import LandingPage from "@/pages/LandingPage";
import MapView from "@/pages/MapView";

function AppRouter() {
  const location = useLocation();
  const { lang } = useI18n();
  useSEO(lang);

  // Synchronous check for OAuth callback to avoid race condition
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/browse" element={<Browse />} />
        <Route path="/listing/:id" element={<ListingDetail />} />
        <Route path="/post" element={<CreateListing />} />
        <Route path="/post/:id" element={<CreateListing />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/messages/:conversationId" element={<Messages />} />
        <Route path="/alerts" element={<AlertsPage />} />
        <Route path="/payment/return" element={<PaymentReturn />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        {/* SEO landing pages. One component handles every variant via params. */}
        <Route path="/skelbimai/:city" element={<LandingPage />} />
        <Route path="/skelbimai/:city/:category" element={<LandingPage />} />
        <Route path="/kategorija/:category" element={<LandingPage />} />
        <Route path="/atiduodu" element={<LandingPage mode="free" />} />
        <Route path="/atiduodu/zemelapis" element={<MapView />} />
        <Route path="/atiduodu/:city" element={<LandingPage mode="free" />} />
        <Route path="/aukcionai" element={<LandingPage mode="auction" />} />
      </Routes>
      <Footer />
      <AuthModal />
    </>
  );
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
